import React from "react";
import useTicketTypeInfoController from "./useTicketTypeInfo.controller.js";
import { PlaneTicketReturnIcon } from "@bookingcom/bui-assets-react/streamline";
import { Icon, Link, Stack, Text } from "@bookingcom/bui-react";
import { Trans } from "@bookingcom/lingojs-react";
import useProfiler from "../../../../../../../hooks/useProfiler.js";
import { track } from "@flights/et-universal";
const useTicketTypeInfo = (flight) => {
    const { header, contentDirection, contentAlignment, contentGap, title, subtitle, supplierTermsLink, status, isPreSelected } = useTicketTypeInfoController(flight);
    const { isMobile, isDesktop } = useProfiler();
    if (!isPreSelected)
        return undefined;
    return {
        header,
        content: (isDesktop() && !!track("flights_funnel_new_fd_page_desktop")) ||
            (isMobile() && !!track("flights_funnel_new_fd_page_mobile")) ? undefined : (React.createElement(Stack, { gap: 4, direction: "row" },
            React.createElement(Icon, { svg: PlaneTicketReturnIcon, size: "larger" }),
            React.createElement(Stack.Item, { shrink: true, grow: true },
                React.createElement(Stack, { direction: contentDirection, alignItems: contentAlignment, grow: true, gap: contentGap },
                    React.createElement(Stack.Item, { grow: true },
                        React.createElement(Stack, { gap: 4 },
                            React.createElement("div", null,
                                React.createElement(Text, null,
                                    title,
                                    " "),
                                React.createElement(Text, null, subtitle)),
                            supplierTermsLink && (React.createElement("div", null,
                                React.createElement(Trans, { tag: "flights_ancillary_offer_flexticket_tandc", variables: {
                                        start_link: "<0>",
                                        end_link: "</0>"
                                    }, components: [React.createElement(Link, { key: 0, href: supplierTermsLink, attributes: { target: "_blank" } })] }))))),
                    React.createElement(Text, { color: "constructive", variant: "body_2" }, status)))))
    };
};
export default useTicketTypeInfo;
